const bus = new EventTarget();

export const emitEvent = (type, detail = {}) => {
	if (!type) return;
	bus.dispatchEvent(new CustomEvent(type, { detail }));
};

export const onEvent = (type, handler) => {
	if (!type || !handler) return () => {};
	const wrapped = (event) => handler(event?.detail);
	bus.addEventListener(type, wrapped);
	return () => bus.removeEventListener(type, wrapped);
};

export default {
	on: onEvent,
	emit: emitEvent,
};
